import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

import {
  DeviceService,
  IconSizeEnum,
  ImageRatioEnum,
  IProductCard, SdBannerComponent, SdButtonComponent, SdButtonIconComponent, SdIconComponent,
  SdIsCollapsibleDirective
} from '@seb/web-design-system/core';
import { GetValuePipe } from '../getValue.pipe';

@Component({
  selector: 'sd-product-comparator-sticky',
  templateUrl: './product-comparator-sticky.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./product-comparator-sticky.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdIconComponent,
    SdBannerComponent,
    SdButtonIconComponent,
    SdButtonComponent,
    TranslateModule,
    SdIsCollapsibleDirective
  ],
  providers: [
    GetValuePipe
  ]
})
export class SdProductComparatorStickyComponent
implements OnInit, OnChanges, OnDestroy
{
  constructor(
    private cdRef: ChangeDetectorRef,
    private deviceService: DeviceService,
  ) {}

  isMobile$: boolean;
  iconSize = IconSizeEnum;
  mobileSubscription: Subscription;
  isOpen = false;
  imageRatio = ImageRatioEnum;
  emptyProducts;

  @Input()
  maxProducts = 4;

  @Input()
  comparedProducts: IProductCard[];

  @Output()
  deleteProduct = new EventEmitter<string>();

  @Output()
  compareProducts = new EventEmitter<string[]>();

  ngOnInit() {
    this.mobileSubscription = this.deviceService.isMobile.subscribe((x) => {
      this.isMobile$ = x;
      this.cdRef.markForCheck();
    });
  }

  ngOnChanges() {
    if (this.comparedProducts && this.maxProducts) {
      this.comparedProducts = this.comparedProducts.slice(0, this.maxProducts);
      this.emptyProducts = Array(
        this.maxProducts - this.comparedProducts.length,
      )
        .fill('')
        .map((x, i) => i);
    }
  }

  ngOnDestroy() {
    this.mobileSubscription?.unsubscribe();
  }

  onDelete(product: string) {
    this.deleteProduct.emit(product);
  }

  validateComparison() {
    this.compareProducts.emit(
      this.comparedProducts.map((product) => product.code),
    );
  }

  trackByProductCode(index: number, product: IProductCard): string {
    return product.code;
  }
}
